import { TriangleAlert, Save } from 'lucide-react';
import { toast } from 'sonner';
import { pitClashes } from '../lib/pitClash';

export const PIT_LINE_STATES = ['ok', 'coat', 'band', 'exposed'];
export const pipeLabel = (p, t) => [p.name, t['type_' + p.type], p.sub ? t['sub_' + p.sub] : '', p.dn ? `DN ${p.dn}` : ''].filter(Boolean).join(' · ');

// pipes/cables in (or ≤1 m around) an excavation pit – always checks ALL pipes
export default function PitLines({ t, pit, project, onPatch, onPipePatch }) {
  const hits = pitClashes(pit, project);
  if (!hits.length) return <p className="pit-lines-none" data-testid="pit-lines-none">{t.plNone}</p>;
  const rec = pit.lines || {};
  const set = (id, p) => onPatch({ lines: { ...rec, [id]: { ...rec[id], ...p } } });
  return (
    <div className="pit-lines" data-testid="pit-lines">
      <div className="pit-alarm" data-testid="pit-clash-alarm"><TriangleAlert size={18} /> <b>{t.plAlarm}</b> <span>({hits.map(({ pipe }) => pipeLabel(pipe, t)).join(', ')})</span></div>
      <h5>{t.plTitle}</h5>
      {hits.map(({ pipe, d }) => {
        const r = rec[pipe.id] || {};
        const inp = (k, ph, mode = 'decimal') => <input inputMode={mode} data-testid={`pit-line-${k}-${pipe.id}`} placeholder={ph} value={r[k] ?? ''} onChange={(e) => set(pipe.id, { [k]: e.target.value })} />;
        return (
          <div key={pipe.id} className={`pit-line ${r.excluded ? 'excluded' : ''}`} data-testid={`pit-line-${pipe.id}`}>
            <div className="pit-line-head"><i style={{ background: pipe.color || '#64748b' }} /><b>{pipeLabel(pipe, t)}</b><small>{d ? `${d.toFixed(2)} m` : t.plCrossing}</small></div>
            <label className="pit-line-inc"><input type="checkbox" data-testid={`pit-line-include-${pipe.id}`} checked={!r.excluded} onChange={(e) => set(pipe.id, { excluded: !e.target.checked })} /> {r.excluded ? t.plExcluded : t.plIncluded}</label>
            {!r.excluded && (
              <div className="pit-line-grid">
                <label>{t.plDepth}{inp('depth', pipe.depth ?? '1,30')}</label>
                <label>{t.plDist}{inp('dist', '0,80')}</label>
                <label>{t.plMat}{inp('mat', pipe.material || 'PE-HD', 'text')}</label>
                <label>DN / Ø{inp('dn', pipe.dn || '100', 'text')}</label>
                <label>{t.plState}
                  <select data-testid={`pit-line-state-${pipe.id}`} value={r.state || 'ok'} onChange={(e) => set(pipe.id, { state: e.target.value })}>
                    {PIT_LINE_STATES.map((s) => <option key={s} value={s}>{t['plSt_' + s]}</option>)}
                  </select>
                </label>
                <button className="btn btn-outline btn-sm" data-testid={`pit-line-sync-${pipe.id}`} onClick={() => {
                  const num = (v) => (v === '' || v == null ? undefined : +String(v).replace(',', '.'));
                  onPipePatch(pipe.id, Object.fromEntries(Object.entries({ depth: num(r.depth), material: r.mat || undefined, dn: r.dn || undefined }).filter(([, v]) => v !== undefined)));
                  toast.success(t.plSynced);
                }}><Save size={13} /> {t.plSync}</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
